import { useMemo } from 'react'
import { Select, SelectProps, Text } from 'ui'
import { components } from 'react-select'
import { useCompanyPositions } from 'queries/company'
import { isDrivingPosition } from 'pages/ShiftEditorPage/drivingPosition'

interface Props extends Omit<SelectProps, 'value'> {
  includeAll?: boolean
  value?: number
  excludeLeadPositions?: boolean
}

const ALL_POSITION_OPTION = {
  label: 'All Driving Positions',
  value: 0,
}

export function DrivingPositionsSelector(props: Props) {
  const { includeAll, excludeLeadPositions, ...otherProps } = props
  const { data, isLoading } = useCompanyPositions()

  const options = useMemo(() => {
    if (!data) return []
    const optionItems = data
      .filter((p) => !p.hidden && isDrivingPosition(p))
      .filter(
        (p) =>
          !excludeLeadPositions ||
          !p.isShiftLeadPosition ||
          Number(p.id) === props.value
      )
      .map((item) => ({
        label: item.name,
        value: Number(item.id),
      }))

    if (includeAll) {
      return [ALL_POSITION_OPTION, ...optionItems]
    }

    return optionItems
  }, [data, includeAll, excludeLeadPositions, props.value])

  const value = useMemo(() => {
    return options.find((option) => option.value === props.value)
  }, [props.value, options])

  return (
    <Select
      aria-label={'Driving Positions Selector'}
      options={options}
      {...otherProps}
      isLoading={isLoading}
      isMulti={false}
      value={value}
      components={{
        NoOptionsMessage: (msgProps) => (
          <components.NoOptionsMessage {...msgProps}>
            <Text color={'primary'} textAlign={'left'}>
              There are no driving positions yet. Add a new one.
            </Text>
          </components.NoOptionsMessage>
        ),
      }}
    />
  )
}
